import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
  /** No padding around the body, for tables. */
  flush?: boolean;
}

export function Card({ title, actions, flush = false, className, children, ...rest }: CardProps) {
  return (
    <section className={cx('eb-card', className)} data-flush={flush} {...rest}>
      {title || actions ? (
        <header className="eb-card__head">
          <h2 className="eb-card__title">{title}</h2>
          {actions}
        </header>
      ) : null}
      <div className="eb-card__body">{children}</div>
    </section>
  );
}
